'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _PlatformApi2 = require('./PlatformApi');

var _PlatformApi3 = _interopRequireDefault(_PlatformApi2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable sort-keys */
var endpoints = {
  actionTypes: {
    many: '/{parent}/actiontypes',
    params: {
      parent: 'publisher'
    }
  },

  facebook: {
    customAudiences: {
      many: '/facebook/customaudiences/',
      one: '/facebook/customaudiences/{record}',
      params: {
        record: 'audienceId'
      },
      queryParams: ['credentialId', 'ad_account_id', 'limit']
    },
    pages: {
      many: '/facebook/pages/',
      one: '/facebook/pages/{record}',
      params: {
        record: 'pageId'
      },
      queryParams: ['credentialId', 'limit']
    }
  },
  customSocialApi: {
    many: '/social/{network}/{url}',
    params: {
      network: 'publisher',
      url: 'url'
    },
    queryParams: ['credential_id'],

    xandr: {
      many: '/social/xandr/{url}',
      params: {
        url: 'url'
      },
      queryParams: ['credential_id', 'num_elements']
    }
  },

  syncedAdAccount: {
    many: '/ad_accounts'
  },

  tokens: {
    many: '/tokens',
    queryParams: ['publishers'],

    adAccounts: {
      many: '/tokens/{parent}/ad_accounts',
      params: {
        parent: 'credentialId'
      }
    },

    adAccount: {
      many: '/tokens/{parent}/ad_accounts/{record}',
      params: {
        parent: 'credentialId',
        record: 'entityId'
      },
      body: {
        canCollect: 'can_collect',
        shouldCollect: 'should_collect'
      }
    }
  },

  token: {
    one: '/{record}/token',
    params: {
      record: 'publisher'
    },
    delete: {
      many: '/{parent}/token/{record}',
      params: {
        record: 'credentialId',
        parent: 'publisher'
      },
      queryParams: ['credentialId']
    },
    bySocialAccount: {
      many: '/{parent}/account/{record}/token',
      params: {
        record: 'accountId',
        parent: 'publisher'
      },
      queryParams: ['valid']
    },
    validate: {
      one: '/{record}/token/validate',
      params: {
        record: 'publisher'
      },
      queryParams: ['credentialId', 'fields', 'identityId']
    }
  }
  /* eslint-enable sort-keys */

};var defaultOptions = {
  prefix: '/publisher'
};

var PublisherApi = function (_PlatformApi) {
  (0, _inherits3.default)(PublisherApi, _PlatformApi);

  function PublisherApi(options) {
    (0, _classCallCheck3.default)(this, PublisherApi);

    var o = (0, _assign2.default)({}, defaultOptions, options);

    var _this = (0, _possibleConstructorReturn3.default)(this, (PublisherApi.__proto__ || (0, _getPrototypeOf2.default)(PublisherApi)).call(this, o));

    _this._endpoints = (0, _assign2.default)({}, _this._endpoints, endpoints);
    return _this;
  }

  return PublisherApi;
}(_PlatformApi3.default);

exports.default = PublisherApi;
//# sourceMappingURL=PublisherApi.js.map